import { useEffect } from 'react'

import { createUserRepository } from 'auth/infra/UserRepository'
import useAnalytics from 'core/analytics/useAnalytics'
import { createTokenInterceptor, HttpClient } from 'core/infra/http/HttpClient'
import { SentryWrapper } from 'core/infra/sentry/SentryWrapper'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

export function useInitApplication() {
  const { init, identifyStoredUser } = useAnalytics()

  const userRepository = createUserRepository({
    storage: new LocalStorageClient(),
  })

  HttpClient.setup({
    request: createTokenInterceptor({ userRepository }),
  })

  SentryWrapper.init()

  useEffect(() => {
    init()
    identifyStoredUser()
  }, [init, identifyStoredUser])
}
